'use client'

import { CheckboxToggle } from './Toggle'
import '@/styles/checkbox-list.css'

export interface CheckboxListOption {
  value: number | string
  label: string
  description?: string
}

interface CheckboxListProps {
  label?: string
  options: CheckboxListOption[]
  value: Array<number | string>
  onChange: (value: Array<number | string>) => void
  columns?: 1 | 2 | 3
  emptyMessage?: string
}

export function CheckboxList({
  label,
  options,
  value,
  onChange,
  columns = 2,
  emptyMessage = 'Seçenek yok',
}: CheckboxListProps) {
  const current = new Set(value.map(String))

  const toggle = (optionValue: number | string, checked: boolean) => {
    const key = String(optionValue)
    const next = new Set(current)
    if (checked) next.add(key)
    else next.delete(key)

    const values = options
      .filter(option => next.has(String(option.value)))
      .map(option => option.value)
    onChange(values)
  }

  return (
    <div className="checkbox-list">
      {label && <div className="checkbox-list__label">{label}</div>}
      {options.length === 0 ? (
        <div className="checkbox-list__empty">{emptyMessage}</div>
      ) : (
        <div className={`checkbox-list__grid checkbox-list__grid--${columns}`}>
          {options.map(option => (
            <CheckboxToggle
              key={String(option.value)}
              checked={current.has(String(option.value))}
              onChange={checked => toggle(option.value, checked)}
              label={option.label}
              description={option.description}
            />
          ))}
        </div>
      )}
    </div>
  )
}
